<template>
  <div>
  <div class="mycouponPage">
      <XR-head titleText="优惠券历史记录" ref="headObj"></XR-head>
      <v-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" ref="scroll">
        <mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="0" :title="'可用'+'('+ couponCount.NoUse +')'"/>
          <mu-tab value="1" :title="'已使用'+'('+ couponCount.Use +')'"/>
          <mu-tab value="2" :title="'已过期'+'('+ couponCount.Overdue +')'"/>
        </mu-tabs>
        <div v-for="(couponRow,index) in couponList" :key="index" class="coupon_default_inner" > 
          <template > 
            <div class="coupon_default_name" @click="open(index)">
              <div :class="(couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?'couponGrey':(couponRow.CouponType==0? 'couponRink':'couponYellow'))" class="couponLeft" >
                  <div class="coupon_discount" >
                      <p class="cost">￥</p>
                      <p class="money">{{couponRow.Money}}</p>
                  </div>
              </div>
              <div class="couponRight" :class="(couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?'couponGrey':(couponRow.CouponType==0? 'couponRink':'couponYellow'))">              
                <div class="coupon_content" :style="{width:couponWidth+'px'}">
                  <p class="coupon_title">
                    <span class="coupon_type">{{couponRow.CouponTypeName}}</span> {{couponRow.Name}}
                  </p>
                  <p class="date">
                      使用时间：{{couponRow.StartTime}}-{{couponRow.EndTime}}
                  </p> 
                  <p class="limit" v-if="couponRow.FullMoney>0">
                      使用门槛：满{{couponRow.FullMoney}}元可用
                  </p>
                  <p class="limit" v-if="couponRow.FullMoney==0">
                      使用门槛：无门槛
                  </p>                         
                </div>
              </div>
            </div>
            <div class="btn" :style="{backgroundImage: 'url(' + (couponRow.Status=='已使用'||couponRow.Status=='已过期'||couponRow.Status=='未开始'||couponRow.Status=='已锁定'?bg3:(couponRow.CouponType==0? bg1:bg2)) + ')'}">
                <mu-flat-button v-if="couponRow.Status=='未使用'" @click="btnClick(couponRow.Id)" label="去使用" class="demo-flat-button" primary/>
                <span v-if="couponRow.Status=='已使用'">已使用</span>
                <span v-if="couponRow.Status=='已过期'">已过期</span>
				<span v-if="couponRow.Status=='未开始'">未开始</span>
                <span v-if="couponRow.Status=='已锁定'">已锁定</span>
            </div>
          </template>
        </div>
      </v-scroll>
      <mu-dialog dialogClass="myCoupon" :open="dialog" v-if="couponList.length>0">
        <img class="logo" src="/static/coupon/dialog-top.png" alt="">
        <div class="close">
             <mu-icon-button @click="close">
                <span>×</span>
              </mu-icon-button>
              <p></p>
        </div>
        <div class="dialogTop">
          <p class="title">{{couponList[openCount].Name}}</p>
          <P class="couponType"> {{couponList[openCount].Money}}元{{couponList[openCount].CouponTypeName}}</P>
          <div class="dialogPrice">
            <div class="dialog_bg">
              {{couponList[openCount].Money}} <span>元</span> 
            </div> 
          </div>
          <p class="utility_time">使用时间:{{couponList[openCount].StartTime}}-{{couponList[openCount].EndTime}}</p>
          <p class="limit" v-if="couponList[openCount].FullMoney>0">
              使用门槛：满{{couponList[openCount].FullMoney}}元可用
          </p>
          <p class="limit" v-if="couponList[openCount].FullMoney==0">
              使用门槛：无门槛
          </p> 
        </div>
        <div class="dialogBottom">
          <p class="produce"><span></span>使用说明</p>
          <div class="inner">
              <div v-html="couponList[openCount].Content"></div>
          </div>
        </div>
      </mu-dialog>
      <XR-toast ref="XRtoast"></XR-toast>
      <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      activeTab: '0',
      dialog: false,
      bg1:'/static/coupon/couponCenter1-4.png',
      bg2:'/static/coupon/couponCenter1-5.png',
      bg3:'/static/coupon/couponCenter1-6.png',
      couponWidth: document.documentElement.clientWidth-20-60-16-88,
      pageEnd : 0, // 结束页数
      num:15,
      scrollDone:function(){},
      searchInfo:{
        Status:0,
        pageIndex:0
      },
      couponList: [],
      couponCount: {
        NoUse:0,
        Overdue:0,
        Use:0
      },
      openCount:0,
      }
    },
    mounted:function(){
      if (!this.$store.state.user.SessionId) {
        this.loginUrl = "/Login";
        return;
      }else{
        console.log(this.$store.state.user.SessionId)
        this.WapMyCouponHistoryCount()
        this.WapMyCouponHistoryList(true)
      }
    },
    methods: {
      WapMyCouponHistoryList(isNewSearch){
          this.$refs.XRtoast.load()
          if(isNewSearch){        
            this.searchInfo.pageIndex = 1
          }
          else{
            this.searchInfo.pageIndex++
          }    
          var ths = this;
          var url = '/Shop/CouponServer/WapMyCouponHistoryList';
          ths.$post(url,
          JSON.stringify(this.searchInfo)
          ).then(function (res){
            ths.scrollDone()
            ths.$refs.XRtoast.hide()
            if(!res.IsSuccess){
              if(isNewSearch){
                ths.couponList = []    
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
                ths.$refs.XRtoast.hide(res.Msg, true)
              }else{            
                ths.$refs.XRtoast.failed(res.Msg, true)
              }
              
            }else{
              if(isNewSearch){
                ths.couponList = res.Data.List
              }
              else{            
                for(var i = 0; i < res.Data.List.length;i++){            
                  ths.couponList.push(res.Data.List[i])
                }
              }
              ths.pageEnd = res.Data.Rows%ths.num!=0? res.Data.Rows/ths.num+1:res.Data.Rows/ths.num
              if(ths.couponList.length <= 0){            
                ths.$refs.XRPageTip.ShowEmpty(res.Msg)
              }else{            
                ths.$refs.XRPageTip.initTip()
              }
              ths.loaded =false
              ths.$refs.XRtoast.hide()
            }
          });
        },
        WapMyCouponHistoryCount(){
          var ths = this
          ths.$post('/Shop/CouponServer/WapMyCouponHistoryCount')
            .then(function (res) {
              if(res.IsSuccess){
                ths.couponCount = res.Data
              }
            })
        },
        onRefresh(done) {
		  this.WapMyCouponHistoryList(true)
		  this.WapMyCouponHistoryCount()
          done() // call done      
        },
		btnClick(id){
          this.$router.push('/retail/coupon/couponUsingRemark?id='+id)
        },
        onInfinite(done) {
          this.scrollDone = done
          if(this.searchInfo.pageIndex+1 > this.pageEnd){
          
            //this.$refs.XRtoast.failed("已经到最后一页", true)\
            this.$refs.scroll.infiniteDone()
            return
          }
          this.WapMyCouponHistoryList(false);     
        },
        open (index) {
          if(this.couponList[index].Status=='已使用'||this.couponList[index].Status=='已过期'){
            this.dialog = false
          }
          else{
            this.dialog = true
            this.openCount = index
          }
            
          },
        close () {
          this.dialog = false
        },
        handleTabChange (val) {
          this.activeTab = val
          this.searchInfo.Status = val
          this.WapMyCouponHistoryList(true)
        },
    }
  }
</script>
<style>
  .mycouponPage .mu-tabs{
    background: #fff;
  }
  .mycouponPage .mu-tabs .mu-tab-link .mu-tab-text{
    color: #999;
  }
  .mycouponPage .mu-tabs .mu-tab-active .mu-tab-text{
    color: #E95E88;
  }
  .mycouponPage{
    width: 100%;  
  }
  .mycouponPage .coupon_default_inner{
    width: 100%;
    display: flex;
    padding: 0 10px;
    margin-top: 10px;
    background-size: 100% 100%; 
    
  }
  .mycouponPage .coupon_default_inner .btn{
    background-size:100% 100%; 
    padding: 0 12px;
    display: flex;
    align-items: center;
  }
  .mycouponPage .coupon_default_inner .coupon_default_name{
    display: flex;
    background-image: url('../../../../static/coupon/couponCenter2-2.png');
    background-size: 100% 100%;
  }
  .mycouponPage .coupon_default_inner .couponLeft{
    padding: 10px 0;
    background-size:100% 100%; 
  }
  .mycouponPage .coupon_default_inner .couponLeft .coupon_discount{
    width: 60px;
    height: 60px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    margin: 0 8px;
    margin-top: 4px;
  }
  .mycouponPage .coupon_default_inner .couponLeft.couponRink .coupon_discount{
    background: #E95E88;
  }
  .mycouponPage .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
    background: #999;
  }
  .mycouponPage .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
    background: orange;
  }
  .mycouponPage .coupon_default_inner .coupon_discount .cost{
    height: 20px;
    line-height: 30px;
  }
  .mycouponPage .coupon_default_inner .coupon_discount .money{
    font-size: 26px;
    height: 30px;
    line-height: 30px;
  }  
  .mycouponPage .coupon_default_inner .couponRight{
    padding: 10px 0;
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content{
    padding: 0 8px;
    border-right: 1px dotted #999;
    
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content p{
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content .coupon_title{
    height: 25px;
    line-height: 25px;
    font-size: 16px;
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
    border-radius: 3px;
    padding: 2px 5px;
    font-size: 12px;
  }
  .mycouponPage .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
    border: 1px solid #E95E88;
    color: #E95E88;
  }
  .mycouponPage .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
    border: 1px solid #999;
    color: #999;
  }
  .mycouponPage .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
    border: 1px solid orange;
    color: orange;
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content .date{
    font-size: 12px;
    color: #666;
    margin-top: 10px;
  }
  .mycouponPage .coupon_default_inner .couponRight .coupon_content .limit{
    font-size: 12px;
    color: #666;
  }
  .mycouponPage .coupon_default_inner .btn span{
    width: 64px;
    text-align: center;
  }
  .mycouponPage .coupon_default_inner .btn .mu-flat-button{
    width: 64px;
    min-width: 64px;
    height: 26px;
    background: red;
  }
  .mycouponPage .coupon_default_inner .btn .mu-flat-button .mu-flat-button-label{
    color: #fff;
    padding: 0;
    font-size: 12px;
  }
  .mu-dialog.myCoupon{
    position: relative;
    background: none;
  }
  .mu-dialog.myCoupon .mu-dialog-body img.logo{
    width: 20%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -30px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .close{
    position: absolute;
    right: 10px;
    top: -50px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .close .mu-icon-button{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    padding: 0;
    background: #eee;
  }
  .mu-dialog.myCoupon .mu-dialog-body .close .mu-icon-button span{
    font-size: 26px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .close p{
    width: 1px;
    height: 19px;
    border-left:1px dotted #ccc;
    margin-left: 15px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogTop{
    padding:24px 16px 0 16px;
    background-image: url('../../../../static/coupon/dialog-bg2.png');
    background-size:100% 100%; 
  }
  .mu-dialog.myCoupon .mu-dialog-body .title{
    text-align: center;
    color: #000;
    font-size: 18px;
    margin-top: 5px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .couponType{
    color: #000;
    font-size: 22px;
    text-align: center;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogPrice{
    margin-top: 5px;
    width: 100%;
    justify-content: center;
    border-radius: 5px;
    border: 2px solid #aaa;
    display: flex;
    width: 90%;
    margin-left: 5%;
    align-items: center;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogPrice .dialog_bg{
    width: 70%;
    height: 60px;
    background-image: url('/static/coupon/dilog.png');
    background-size:100% 100%; 
    margin: 8px 0;
    font-size: 28px;
    color: #fff;
    text-align: center;
    line-height: 60px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .utility_time{
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .limit{
    text-align: center;
    font-size: 14px;
    padding-bottom: 5px;
    border-bottom: 1px dashed #999;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogBottom{
    padding: 10px 0;
    background-image: url('../../../../static/coupon/dialog-bg.png');
    background-size:100% 100%; 
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogBottom .produce{
    padding: 0 16px;
    font-size: 14px;
    line-height: 20px;
  } 
  .mu-dialog.myCoupon .mu-dialog-body .dialogBottom .produce span{
    width: 3px;
    height: 16px;
    background: red;
    margin-right: 10px;
    display: block;
    float: left;
    margin-top: 2px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogBottom .inner{
    margin: 6px 0 0 0;
    text-align: left;
    height: 80px;
    overflow: auto;
    padding: 0 16px;
  }
  .mu-dialog.myCoupon .mu-dialog-body .dialogBottom .inner ul{
    list-style: none;
    font-size: 12px;
    height: 100%;
  }
  .mycouponPage .xr-pageTip{
    top: 104px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/retail/coupon/myCoupon.vue